import { displayUnitOfMeasure } from '../utils/unitOfMeasureUtils';
import {
    resolveLastStoredCombinedUM,
    wouldCombinedUMDecrease,
} from '../utils/reportUtils';

type UMCounterUnitFields = {
    currentUMCounterValue?: number | null;
    currentMachineHours?: number | null;
    replacedUMCounterValue?: number | null;
    unitOfMeasure?: string | null;
};

type UMCounterLowReadingWarningProps = {
    enteredValue?: string | number | null;
    /** Unit counters used to compute previous vs proposed combined (face + replaced) totals. */
    unit?: UMCounterUnitFields | null;
    unitOfMeasure?: string | null;
};

/**
 * Warn when the entered face reading would lower the combined running total
 * (current meter + replaced counter). Does not block submit.
 */
export const UMCounterLowReadingWarning = ({
    enteredValue,
    unit,
    unitOfMeasure,
}: UMCounterLowReadingWarningProps) => {
    const previousCombined = resolveLastStoredCombinedUM(unit);
    if (!wouldCombinedUMDecrease(enteredValue, unit) || previousCombined == null) {
        return null;
    }

    const umLabel = displayUnitOfMeasure(unitOfMeasure ?? unit?.unitOfMeasure) || 'units';
    const message = `This reading would bring the combined meter total below the last recorded total of ${previousCombined.toLocaleString()} ${umLabel} (current meter + replaced counter). Please double-check the machine meter. If the counter was replaced, confirm the replaced counter has been recorded on the unit first.`;

    return (
        <div className="um-counter-low-reading-warning" role="status">
            {message}
        </div>
    );
};

export default UMCounterLowReadingWarning;
